module.exports = __webpack_public_path__ + "static/img/development.8ffcc9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/development.png
// module id = T3hb
// module chunks = 1